import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailers-server_driven_slate_event-action_unknown';

/**
 * The unified action event for SDUI aims to capture all kinds of events happening on the View, Section, or Component level. Parameters  including:
&gt; requestId - non-null - Request ID generated by Backend API
&gt; viewDisplayPage - non-null - Display page type, e.g. HOMEPAGE, CATEGORY_PAGE, …
&gt; viewInstanceIdentifier - nullable - e.g. Category page&#39;s category identifier, Product page&#39;s product token
&gt; sectionType - non-null - The type of the Section this event is firing
&gt; sectionPosition - non-null (index) - The position of the Section on the View this event is firing
&gt; actionType - non-null - The type of the Action of the event, e.g. VIEW, CLICK
&gt; componentName - nullable - Name of the component of the Component this event is firing, e.g. recommender_name
&gt; componentInstanceIdentifier - nullable - Identifier of the Component this event is firing, e.g. category identifier
&gt; componentType - nullable - The type of Component this event is firing
&gt; componentPosition - nullable - The position of Component in section
&gt; actionContent - product token(s), brand token(s), category(s), filter content, page number - nullable
&gt; actionPositions - same length as action contents - nullable
&gt; actionInstanceIdentifier - any extra information product want to track
*/
export function trackRetailersServerDrivenSlateEvent(
  requestId_string: string,
  viewDisplayPage_string2: string,
  viewInstanceIdentifier_string3: string,
  sectionType_string4: string,
  sectionPosition_string5: string,
  actionType_string6: string,
  componentName_string7: string,
  componentInstanceIdentifier_string8: string,
  componentType_string9: string,
  componentPosition_string10: string,
  actionContent_string11: string,
  actionPositions_string12: string,
  actionInstanceIdentifier_string13: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    bypassSessionRecording: true,
    realTimeTracking: false,
    parameters: {
      requestId_string,
      viewDisplayPage_string2,
      viewInstanceIdentifier_string3,
      sectionType_string4,
      sectionPosition_string5,
      actionType_string6,
      componentName_string7,
      componentInstanceIdentifier_string8,
      componentType_string9,
      componentPosition_string10,
      actionContent_string11,
      actionPositions_string12,
      actionInstanceIdentifier_string13,
    },
  });
}
